import React from "react";

const KeratinBook = () => {
  return (
    <div className="botoxHeadContainer">
      <h2>Book Your Keratin Hair Treatment in Bangalore Today!</h2>
      <p>
        If you’re ready to transform your hair with a{" "}
        <a href="https://scentlifestyle.com/hair-salon">
          keratin hair treatment in Bangalore
        </a>
        , look no further than SCENT. Our expert stylists are here to help you
        achieve the smooth, shiny, and manageable hair you’ve always wanted.
        Don’t let frizz and unruly hair hold you back any longer. Contact SCENT
        today to schedule your appointment for the best keratin hair treatment
        in Bangalore.
      </p>
      <p>
        At SCENT, we’re dedicated to helping you look and feel your best. With
        our{" "}
        <a href="https://scentlifestyle.com/keratin-hair-treatments-in-bangalore">
          keratin hair treatment in Bangalore{" "}
        </a>
        , you can enjoy beautiful, healthy hair that’s easy to style and
        maintain. Say goodbye to frizz and hello to smooth, sleek locks with our
        professional keratin treatments.
      </p>
    </div>
  );
};

export default KeratinBook;
